import { SignUpType } from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import {
  popSignUp,
  SignUpElement,
} from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import { Button } from "@faire/web/slate-deprecated/Button";
import { Lock } from "@faire/web/slate/icons/foundation/Lock";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { useHistory } from "react-router-dom";

export const LoggedOutCategoryC2AndC3Header = ({
  layoutElement,
}: {
  layoutElement: ILayoutElement;
}) => {
  const history = useHistory();

  const handleSignUp = (
    e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault();
    popSignUp(history, SignUpType.GENERIC, () => {}, {
      element: SignUpElement.HEADER,
      sourceId: "category_page_c2_and_c3_header_signup_cta",
    });
  };

  return (
    <>
      <Typography
        as="h1"
        variant={{
          mobileAndAbove: "displaySSerifRegular",
          desktopAndAbove: "displayMSerifRegular",
        }}
      >
        {layoutElement.main_text}
      </Typography>
      <Spacer height="1x" />
      <Button
        onClick={handleSignUp}
        variant="tertiary"
        style={{ width: "fit-content" }}
      >
        <Lock lockType="foundation" fontSize={16} />
        <Spacer width={4} />
        <StrictLocalMsg
          id="YUPe3W"
          defaultMessage="Unlock wholesale pricing"
          description={{
            text: "sign up cta for discover page header",
          }}
        />
      </Button>
      <Spacer height={{ mobileAndAbove: "2x", tabletAndAbove: "3x" }} />
    </>
  );
};
